/* import the fontawesome core */
import { library, dom } from '@fortawesome/fontawesome-svg-core'

//https://fontawesome.com/search

/* import specific icons */
import {
    faChevronDown,
    faChevronUp,
    faHouse,

} from '@fortawesome/sharp-solid-svg-icons';

import {
    faMapPin,
    faThumbtack,
    faStar // <i class="fa-solid fa-star"></i>  — duotone faStar ships with an empty secondary path, so use solid here.
} from '@fortawesome/pro-solid-svg-icons';


import {
    faUser,
    faEnvelope,
    faChevronsRight,
    faPaperPlane,
    faMessagesQuestion, //<i className="fa-regular fa-messages-question"></i>
    faShieldCat, //<i className="fa-regular fa-shield-cat"></i>
    faRightFromBracket, //<i class="fa-regular fa-right-from-bracket"></i> — logout icon

} from '@fortawesome/pro-regular-svg-icons';

import {
    faYoutube,
    faTwitter,
    faDiscord,
    faSquareXTwitter,
    faCcApplePay,
    faCcStripe,
    faPaypal,
    faStripe,
    faGooglePay,
    faCcMastercard,
    faCcVisa,
    faSteamSquare,
    faSteam,
    faSteamSymbol,
    faFacebook,
    faXTwitter,
    faTwitch // <i className="fa-brands fa-twitch"></i>  (Affiliate)
} from '@fortawesome/free-brands-svg-icons';

import {
    faBagShopping,
    faBagsShopping,
    faShoppingBag,
    faBasketShopping,
    faHandPointer,
    faCashRegister,
    faMoonStars,
    faMoon,
    faSunBright,
    faCircleCheck,
    faCircleXmark,
    faArrowUpLeftFromCircle,
    faCartPlus,
    faCartShopping,
    faCartShoppingFast,
    faUsers,
    faComments,
    faTriangleExclamation,

    faSquareTerminal, // <i className="fa-duotone fa-square-terminal"></i>
    faDatabase, //<i className="fa-duotone fa-database"></i>
    faCreditCard, //<i className="fa-duotone fa-credit-card"></i>
    faPuzzle, // <i className="fa-duotone fa-puzzle"></i>
    faGamepadModern, //<i className="fa-duotone fa-gamepad-modern"></i>
    faPanelEws, //<i className="fa-duotone fa-panel-ews"></i>
    faMicrochip, //<i className="fa-duotone fa-microchip"></i>
    faNetworkWired, //<i className="fa-duotone fa-network-wired"></i>
    faClockRotateLeft, //<i className="fa-duotone fa-clock-rotate-left"></i>  (_benefits_: Backups & scheduled restarts)
    faStethoscope, //<i className="fa-duotone fa-stethoscope"></i>  (_benefits_: AI Server Doctor)
    faTrophy, //<i className="fa-duotone fa-trophy"></i>  (Affiliate)


} from '@fortawesome/pro-duotone-svg-icons';
/*
 *  <font-awesome-icon icon="fa-regular fa-gears"></font-awesome-icon>
 */
export default function setupIcons(){
    /* add icons to the library */
    [
        faFacebook,
        faXTwitter,
        faComments,
        faCartPlus,
        faUsers,
        faCartShopping,
        faCartShoppingFast,
        faArrowUpLeftFromCircle,
        faRightFromBracket,
        faMessagesQuestion, //<i className="fa-regular fa-messages-question"></i>
        faShieldCat, //<i className="fa-regular fa-shield-cat"></i>
        faThumbtack,
        faSteamSquare,
        faSteam,
        faSteamSymbol,
        faChevronUp,
        faSquareTerminal, // <i className="fa-duotone fa-square-terminal"></i>
        faDatabase, //<i className="fa-duotone fa-database"></i>
        faCreditCard, //<i className="fa-duotone fa-credit-card"></i>
        faPuzzle, // <i className="fa-duotone fa-puzzle"></i>
        faGamepadModern, //<i className="fa-duotone fa-gamepad-modern"></i>
        faPanelEws, //<i className="fa-duotone fa-panel-ews"></i>
        faMicrochip, //<i className="fa-duotone fa-microchip"></i>
        faNetworkWired, //<i className="fa-duotone fa-network-wired"></i>
        faClockRotateLeft, //<i className="fa-duotone fa-clock-rotate-left"></i>
        faStethoscope, //<i className="fa-duotone fa-stethoscope"></i>
        faTrophy, //<i className="fa-duotone fa-trophy"></i>
        faTwitch, // <i className="fa-brands fa-twitch"></i>
        faStar, // <i class="fa-solid fa-star"></i>  — solid family (duotone star is broken upstream)
        faSquareXTwitter,
        faCcApplePay,
        faCcStripe,
        faStripe,
        faPaypal,
        faGooglePay,
        faCcMastercard,
        faCcVisa,
        faMapPin,
        faTriangleExclamation,
        faPaperPlane,
        faHouse,
        faChevronsRight,
        faEnvelope,
        faChevronDown,
        faUser,
        faYoutube,
        faTwitter,
        faDiscord,
        faHandPointer,

        faBagShopping,
        faBagsShopping,
        faShoppingBag,
        faBasketShopping,
        faCashRegister,
        faMoonStars,
        faMoon,
        faSunBright,
        faCircleCheck,
        faCircleXmark
    ].forEach(icon => library.add(icon));
    dom.watch();
    console.log("Icons setup 3");
}


